import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const WhyCard = ({
  titulo,
  descripcion,
  link,
  boton,
  colorPrimario = "#eeef20",
  icono,
  shadowColor = "#0d2334",
  iconColor = "#ffff86",
}) => {
  return (
    <div
      className={` w-full h-full flex flex-col relative overflow-hidden rounded-lg rounded-tl-none`}
      style={{
        backgroundColor: colorPrimario,
        boxShadow: `-10px 10px 0px 0px ${shadowColor}`,
      }}
    >
      <div className=" flex-grow p-5 z-10 flex flex-col justify-center gap-5">
        <h3 className="text-2xl xl:text-3xl font-bold text-primario">{titulo}</h3>
        <p className="text-lg xl:text-xl text-blue-4 hyphens-none">{descripcion}</p>
        {(boton && (
          <Link
            to={link}
            className="px-4 py-2 bg-primario w-max text-secundario rounded-full rounded-tl-none font-bold"
          >
            {boton}
          </Link>
        )) ||
          ""}
      </div>
      <div
        className=" absolute -bottom-8 -right-8"
        style={{ color: iconColor }}
      >
        <i class={`fa-solid ${icono} text-[160px] -rotate-12`}></i>
      </div>
    </div>
  );
};

export default WhyCard;
